import { get, post } from "../../service/api";

export const EmailOTPValidation = async (email) => {
  try {
    const response = await get(
      `/merchant/emailValidation?email=${encodeURIComponent(email)}`
    );
    return response;
  } catch (error) {
    console.error("Error EmailOTPValidation:", error);
    throw error;
  }
};

export const EmailVerifyOtp = async (email, otp) => {
  try {
    const response = await post(`/merchant/emailVerifyOtp`, { email, otp });
    return response;
  } catch (error) {
    console.error("Error EmailVerifyOtp:", error);
    throw error;
  }
};

export default EmailOTPValidation;
